export default __webpack_public_path__ + "static/services-fd7dc8f214bb2df04b67379905e00e71.png";